import { useEffect, useState } from "react";
import { ArrowUp, ArrowDown } from "lucide-react";

/**
 * Floating "scroll up / down" buttons. Sits on the right edge above the WhatsApp FAB.
 * Auto-shows after the user has scrolled at least 300px.
 */
export default function ScrollControls() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 300);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!visible) return null;

  return (
    <div className="fixed right-4 bottom-60 md:bottom-36 z-30 flex flex-col gap-2" data-testid="scroll-controls">
      <button
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        className="w-9 h-9 rounded-full bg-white border border-gray-200 shadow-md grid place-items-center text-gray-700 hover:text-[var(--sl-primary)] hover:border-[var(--sl-primary)] transition"
        aria-label="Remonter en haut"
        data-testid="scroll-up"
      >
        <ArrowUp size={14} />
      </button>
      <button
        onClick={() => window.scrollTo({ top: document.body.scrollHeight, behavior: "smooth" })}
        className="w-9 h-9 rounded-full bg-white border border-gray-200 shadow-md grid place-items-center text-gray-700 hover:text-[var(--sl-primary)] hover:border-[var(--sl-primary)] transition"
        aria-label="Descendre en bas"
        data-testid="scroll-down"
      >
        <ArrowDown size={14} />
      </button>
    </div>
  );
}
